import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { useBlockNavigation } from '../../../../common/hooks/useBlockNavigation'
import { Element } from '../../../../common/html/element'
import { Icon } from '../../../../common/html/icon'
import { PopupAction } from '../../../../common/popup/PopupAction'
import { COMPONENTS } from '../../../../routers/constants'
import {
  selectApplyingCriteria,
  selectCriteria,
  selectSelectedIndicatorCount,
} from '../../selectCriteria/store/slice'
import { changeSaveCriteriaPopup } from '../store/slice'

export const BeforeLeavePopup = () => {
  const dispatch = useDispatch()

  const selectedIndicatorCount = useSelector(selectSelectedIndicatorCount)
  const criteriaStr = useSelector(
    selectCriteria([], (data) => JSON.stringify(data)),
  )
  const applyingCriteriaStr = useSelector(
    selectApplyingCriteria((data) =>
      data && data.parameters ? JSON.stringify(data.parameters) : data,
    ),
  )

  const isHasCriteriaFromEmpty =
    !applyingCriteriaStr && !!selectedIndicatorCount
  const isApplyingCriteriaChange =
    !!applyingCriteriaStr &&
    !!selectedIndicatorCount &&
    applyingCriteriaStr !== criteriaStr

  const isBlock = isHasCriteriaFromEmpty || isApplyingCriteriaChange

  const { showPrompt, confirmNavigation, cancelNavigation, lastPathname } =
    useBlockNavigation({
      isBlock,
      ignorePath: [
        COMPONENTS.screening.route,
        COMPONENTS.screening.components.savedCriteria.route,
      ],
    })

  const handleAllowSave = () => {
    cancelNavigation()
    dispatch(changeSaveCriteriaPopup({ isShow: true, lastPathname }))
  }

  return (
    <PopupAction
      isShow={showPrompt}
      title="screening.SAVE_CRITERIA"
      btnTertiary={{
        label: 'screening.CANCEL',
        isI18n: true,
        event: cancelNavigation,
      }}
      btnCancel={{
        label: 'screening.DONT_SAVE',
        isI18n: true,
        event: confirmNavigation,
      }}
      btnSubmit={{
        label: 'screening.SAVE',
        isI18n: true,
        event: handleAllowSave,
      }}
      handleClose={cancelNavigation}
    >
      <Element className="textCenter pb2">
        <Icon
          className="icon-alert"
          style={{ color: '#E8B714', fontSize: 32 }}
        />
        <Element className="pt2" style={{ color: '#3A414B' }}>
          <Translate value="screening.SAVE_CRITERIA_BEFORE_LEAVE_MESS" />
        </Element>
      </Element>
    </PopupAction>
  )
}
